"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GATEWAY_SCOPES_TYPES = exports.GATEWAY_SCOPES = void 0;
var GATEWAY_SCOPES = {
  NON_PRODUCTION_GATEWAY_SCOPE: 'api://39b64b04-e385-4232-a4e2-604367e2d849/.default',
  PRODUCTION_GATEWAY_SCOPE: 'api://39b64b04-e385-4232-a4e2-604367e2d849/.default'
};
exports.GATEWAY_SCOPES = GATEWAY_SCOPES;
var GATEWAY_SCOPES_TYPES = {
  PRODUCTION: 'production',
  NON_PRODUCTION: 'non_production'
};
exports.GATEWAY_SCOPES_TYPES = GATEWAY_SCOPES_TYPES;
Object.freeze(GATEWAY_SCOPES);
Object.freeze(GATEWAY_SCOPES_TYPES);